import {memo, useCallback} from 'react';
import s from './headerLogo.module.css'
import Logo from '../../../utils/images/newLogo/logoWhite.svg'
import {NavLink} from "react-router-dom";
import {goToTop} from "../../../utils/helpers/goToTop";

type HeaderLogoProps = {
  className?: string
}

export const HeaderLogo= memo(({className}: HeaderLogoProps) => {
    const onClickHandler = useCallback(() => {
        goToTop('auto')
    }, [])
    return (
        <NavLink
            to={'/'}
            onClick={onClickHandler}
            className={`${s.header__logoLink} ${className ? className : ''}`}
        >
            <img src={Logo} alt="OpenHalt Logo"/>
        </NavLink>
    );
});
